import { getPartnerFromToken, getPartnerValue } from "../../utils/common/index";

export * from "./homeAction";
export * from "./persistedAction";
export * from "./rechargeSalesAction";
export * from "./activationSales";
export * from "./payoutAction";
export * from "./retailerPerformance";
export * from "./earningsAction";
export * from "./estelLedger";
export * from "./dashboardsAccessibility";
export * from "./ed1AndEd2";
export * from "./edOrdersSummary";
export * from "./schemeOverview";
export * from "./dashboardAudit";
export * from "./potentialIncentiveEarnings";
export const RESET_DATA = "RESET_DATA";
export const SET_STATE_BASED_ON_COOKIES = "SET_STATE_BASED_ON_COOKIES";
export const GET_7DAYS_DATE = "GET_7DAYS_DATE";
export const CLEAR_7DAYS_DATE = " CLEAR_7DAYS_DATE";
export const RESET_SALES = "RESET_SALES";
export const SHOW_ERROR = "SHOW_ERROR";
export const HIDE_ERROR = "HIDE_ERROR";
export const RESET_SCHEME = "RESET_SCHEME";

export function resetData() {
  return {
    type: RESET_DATA,
  };
}

export function resetScheme() {
  return {
    type: RESET_SCHEME,
  };
}

export function resetSalesForValue() {
  return {
    type: RESET_SALES,
  };
}

export function showError() {
  return {
    type: SHOW_ERROR,
  };
}

export function hideError() {
  return {
    type: HIDE_ERROR,
  };
}

export function setStatesBasedHierarchyToken(decoded) {
  const prn = getPartnerFromToken(decoded?.role.toUpperCase());
  const prv = getPartnerValue(prn, decoded);
  
  return {
    type: SET_STATE_BASED_ON_COOKIES,
    payload: decoded,
    partnerRoleName: prn,
    partnerRoleValue: prv,
  };
}
export function get7Days() {
  return {
    type: GET_7DAYS_DATE,
  };
}
export function clear7Days() {
  return {
    type: CLEAR_7DAYS_DATE,
  };
}
